



























































import { Col, Row, Swipe, SwipeItem } from "vant";
import { Component, Vue, Prop } from "vue-property-decorator";
import moreList from "@/components/multiple/moreList.vue";
@Component({
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    moreList,
    "van-row": Row,
    "van-col": Col
  }
})
export default class NewsMultiple extends Vue {
  @Prop()
  private imgList: any;
  @Prop()
  private imgInfo: any;
  @Prop()
  private indexPage: any; // 当前页面的index
  @Prop()
  private imgMoreList: any; // 推荐新闻
  @Prop()
  private showMore: any; // 是否显示推荐新闻
  private current: string = "";
  private vfrom: string = "";

  private newimgList: any = [];
  private innerHeight: any = "";
  private innerWidth: any = "";
  mounted() {
    console.log("xxxx" + this.indexPage);
    this.current = this.indexPage;
    this.vfrom = (this.$route.query.vfrom as string) || "";
    this.innerHeight = window.innerHeight;
    this.innerWidth = window.innerWidth;

    try {
      this.getNewList();
    } catch (error) {
      this.newimgList = this.imgList;
    }
  }

  getNewList() {
    for (let index = 0; index < this.imgList.length; index++) {
      const element = this.imgList[index];
      const _url = element.fileUrl.split("?")[0].split("_")[2];
      const _wh = _url.split(".")[0];
      const w = _wh.split("x")[0];
      const h = _wh.split("x")[1];
      console.log(w, h);
      this.newimgList.push({
        ...element,
        w: w,
        h: h
      });
    }
  }
  onChange(index: string) {
    this.current = index;
    console.log(this.current);
    // 存当前的index 把值传给父组件
    this.$emit("getCurrentIndexV", this.current);
  }
  next() {
    let refswipe: any = this.$refs.swiper;
    refswipe.next();
  }
  prev() {
    let refswipe: any = this.$refs.swiper;
    refswipe.prev();
  }
}
